import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Unit, Users } from '../../../utils/types';
import { getUserSingle } from '../../../utils/apicall/usersApi';
import NotFound from '../../common/404';
import { getUnitsDropDown } from '../../../utils/apicall/commonApi';
import { CONFIG } from '../../../utils/config';
import { authService } from '../../../utils/authServices';

const UserView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<Users | null>(null);
  const [isValidId, setIsValidId] = useState(true);
  const navigate = useNavigate();
  const [units, setUnits] = useState<Unit[]>([]);
  
  useEffect(() => {
    if (!id || isNaN(Number(id))) {
      setIsValidId(false);
    }
  }, [id]);

  const loadData = useCallback(async () => {
    if (isValidId) {
      try {
        const response = await getUserSingle(parseInt(id!, 10));
        if (response) {
          setData(response);
          console.log(response);
        }
      } catch (error) {
        console.error('An error occurred while fetching data.', error);
      }
    }
  }, [id, isValidId]);
  
  const loadUnits = useCallback(async () => {
    try {
      const response = await getUnitsDropDown();
      if (response) {
        setUnits(response);
      }
    } catch (error) {
      console.error('An error occurred while fetching data.', error);
    }
  }, []);
  useEffect(() => {
    loadData();
    loadUnits();
    authService.getTokenExpiration();
  }, [loadData, loadUnits]);

  if (!isValidId) {
    return <NotFound />;
  }


  const getRoleNames = (roles: any[] = []) => {
    if (roles.some(role => role.name.toLowerCase() === 'admin')) return 'Admin';
    if (roles.some(role => role.name.toLowerCase() === 'unitadmin')) return 'Unit Admin';
    if (roles.some(role => role.name.toLowerCase() === 'client')) return 'Client';
    return 'No roles assigned';
  };

   // Helper function to check if a unit is accessible
   const accessibleUnitIds = data?.accessible_units || [];

   const handleBackClick = () => {
    navigate(-1);
  };

  const handleEditClick = (id: any)  => {
    navigate(CONFIG.urls.getUsersEditUrl_Admin(id!), {
      state: { returnTo: CONFIG.urls.getUsersViewUrl_Admin(id!) },
    });
  };

  return (
    <div className="content">
    <section className="ontotita py-5">
      <div className="container">
      <div className="card p-5">
        <div className="row align-items-center">
          <div className="col-md-7">
            <h2 className="h4 text-primary fw-light py-3">Χρήστης</h2>
            </div>
              <div className="col-md-5 text-end">
                  <button className="btn btn-secondary btn-sm"  onClick={() => handleEditClick(data?.id?.toString() || '')}>
                    <i className="bi bi-pencil me-1"></i> Επεξεργασία
                  </button>
                  <button className="btn btn-primary btn-sm ms-2"  onClick={handleBackClick}>
                    <i className="bi bi-arrow-return-left me-1"></i> Επιστροφή
                  </button>
              </div>
                  <hr />
           
         
   
  
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Ονοματεπώνυμο</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-person"></i></span>
              <span className="form-control">{data?.name || 'Loading...'}</span>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-envelope"></i></span>
              <span className="form-control">{data?.email || 'Loading...'}</span>
            </div>
          </div>

        {/*  <div className="mb-3">
            <label htmlFor="password" className="form-label">Κωδικός</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-lock"></i></span>
            </div>
          </div>*/} 

          <div className="mb-3">
            <label htmlFor="role" className="form-label">Ρόλος</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-person-badge"></i></span>
              <span className="form-control">{getRoleNames(data?.roles)}</span>
            </div>
          </div>

            {/* Regional Units Checkboxes */}
          <div className="mb-3">
            <label className="form-label">Περιφερειακές Ενοτήτες</label>
            <div className="d-flex flex-wrap">
              {units.map((unit) => (
                <div key={unit.id} className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`runit-${unit.id}`}
                    name="runits"
                    value={unit.id}
                    checked={accessibleUnitIds.includes(unit.id?.toString() || '')}
                    readOnly
                  />
                  <label className="form-check-label" htmlFor={`runit-${unit.id}`}>
                    {unit.title}
                  </label>
                </div>
              ))}
            </div>
          </div>
          </div>
    </div>
          </div>
        </section>
      </div>
  );
};

export default UserView;
